import { Link } from 'wouter';
import { ArrowRight, Users } from 'lucide-react';
import { SculpturalMesh } from '@/components/SculpturalMesh';

export function TeamPreview() {
  return (
    <section className="py-24 relative isolate overflow-hidden border-y border-border bg-white" id="team-preview">
      <div aria-hidden="true" className="plasmics-mesh-layer">
        <SculpturalMesh variant="funnel" rings={24} spokes={80} twist={-0.8} tiltX={1.15} tiltZ={0.6} gradient={[0.1, 0.7, 0.55, 0.85]} className="absolute top-0 right-0 translate-x-[40%] -translate-y-[55%] md:translate-x-[25%] w-[100vw] md:w-[42vw] max-w-[660px]" opacity={0.8} />
      </div>
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8 mb-12">
          <div className="max-w-2xl">
            <span className="font-mono text-primary text-xs font-bold tracking-[0.3em] uppercase block mb-4 flex items-center gap-3">
              <Users className="w-4 h-4" /> System Builders
            </span>
            <h2 className="text-4xl md:text-5xl font-light text-balance leading-tight">
              Engineering the <span className="font-bold">production stack.</span>
            </h2>
          </div>
          <p className="text-muted-foreground max-w-sm font-light text-sm md:text-base border-l-2 border-primary pl-4">
            Explore the engineering focus behind Plasmics, with development-team updates and a clear route to approved career opportunities.
          </p>
        </div>
        
        <Link href="/team" className="group block relative w-full border border-border bg-muted/20 hover:border-foreground transition-colors overflow-hidden outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
          <div className="absolute top-0 left-0 w-1 h-full bg-primary transform origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500" />
          <div className="p-8 md:p-12 flex flex-col md:flex-row justify-between items-start md:items-center gap-8 relative z-10 bg-white group-hover:bg-white transition-colors">
            <div>
              <h3 className="text-2xl font-bold mb-2 text-foreground group-hover:text-primary transition-colors">Team & Careers</h3>
              <p className="text-muted-foreground font-light text-sm">Discover our focus areas and the latest team and careers information.</p>
            </div>
            
            <div className="px-5 py-4 bg-foreground text-background font-mono text-xs font-bold tracking-widest uppercase flex items-center gap-3 group-hover:bg-primary group-hover:text-foreground transition-all">
              Explore the team
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
